import { render } from "./popularhotelssection.vue?vue&type=template&id=7e8e0c0d"
import script from "./popularhotelssection.vue?vue&type=script&lang=js"
export * from "./popularhotelssection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__